import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import React, { useMemo } from 'react';
import { getLocale, history, useParams } from 'umi';
import { IConfigData } from '@/pages/dashboard/components/PageContainer/type';
import classNames from 'classnames';
import './index.scss';
import SvgIcon from '@home/components/SvgIcon';
import { dynamicString } from '@home/utils/dynamicString';

interface Iprops {
  data: IConfigData;
  config?: {
    subTitle?: string;
    subTitleCn?: string;
  };
  className?: string;
  style?: React.CSSProperties;
}

// 指标详情页，页面标题组件
const MetricDetailTitle = (props: Iprops) => {
  const { data, className, config, style } = props || {};
  const { metric } = useParams<{ metric: string; }>();
  const isEN = getLocale() === LANGUAGE_EN;
  const initialHistoryLength = window.history.length >= 2 ? 2 : 1;
  const { subTitle, subTitleCn } = config || {};

  // 页面标题
  const { title, subTitleContent } = useMemo(() => {
    const metricInfo = data?.metricConfig?.[metric];
    const contact = metricInfo?.contact || 'sallyxue@tencent.com';
    const titleInfo = dynamicString(subTitle || '', { name: contact }) || '';
    const titleInfoCn = dynamicString(subTitleCn || '', { name: contact });
    return {
      title: getName(isEN, metricInfo?.nameEn, metricInfo?.nameCn),
      subTitleContent: getName(isEN, titleInfo, titleInfoCn)
    };
  }, [subTitle, subTitleCn, metric, data, isEN]);


  // 返回逻辑，如果时系统内部，则返回上一页，如果不是则返回首页
  const jumpToBack = () => {
    if (history.action === 'PUSH' || history.length > initialHistoryLength) {
      history.goBack();
    } else {
      history.push(`/benchmark/${data?.frameType || 'mobile'}/explore`);
    }
  };

  return (
    <div
      className={'db-header-title dbb-header-title'}
      onClick={jumpToBack}
    >
      <span className='dbb-header-title-box'>
        {<SvgIcon className='db-header-title-icon dbb-metric-detail-back-icon' type='a-gerenxinxi1'></SvgIcon>}
        <span className={classNames('dbb-metrics-detail-title', className)} style={style}>
          {title}
        </span>
      </span>

      <span className='dbb-metric-detail-title-subtitle'>
        {subTitleContent}
      </span>
    </div>
  );
};

export default MetricDetailTitle;
